export default __webpack_public_path__ + "static/media/KOD0145-min.f65db74f.webp";